export default __webpack_public_path__ + "static/media/file-light.d125b2af.svg";